import tgamConfig from "config/tgam";
import { getUserSophiId } from "lib/identity/api";
import { configureTest } from "lib/tgam-test";
import logger from "utils/logger";
import { getProp } from "utils/utils";

// put yourself in a test bucket with ?sophiBizVariant=control|variant
let qsVariant = window.location.search.match(/sophiRecoTestVariant=(\w+)/gi);
if (qsVariant) {
  qsVariant = qsVariant[0].split("=")[1];
}

// logging utility
function log(msg) {
  return logger.info("[Sophi Recommender test]", msg);
}

/**
 * Push a Sophi 3 analytics event
 * @param {String} testName - the test name (key)
 * @param {String} variant - the variant name
 */
export function sendAnalytics(testName, variant) {
  log(`sending analytics for test "${testName}" with variant "${variant}"`);
  window.sophi && window.sophi.sendEvent({
    type: "ab_tests",
    data: {
      tests: [
        {
          testId: `pb_classic_recommender_context_${testName}`,
          engine: "custom-murmurhash",
          variantName: variant.toLowerCase(),
          store: "visitor"
        }
      ]
    }
  });
}

/**
 * Initialize the test
 * @returns {Object} experiment
 */
export default function initTest() {
  log("running...");
  let error;
  const uuid = getUserSophiId();
  const isStoryPage = getProp(tgamConfig, "meta.isStoryPage", false);
  const isAdmin = getProp(tgamConfig, "env.isPbAdmin", false);
  const {
    recoTestEnabled,
    recoTestKey,
  } = tgamConfig.sophiProps;

  if (isAdmin) {
    error = "PB admin";
  }
  if (!recoTestEnabled) {
    error = "test not enabled";
  }
  if (!uuid) {
    error = "no sophi id";
  }
  if (!isStoryPage) {
    error = "not a story page";
  }
  if (error) {
    log(`will not run: ${error}`);
    return;
  }

  const allocations = [
    { id: "control", percentage: 50 },
    { id: "variant", percentage: 50 }
  ];
  const test = configureTest({ allocations, name: recoTestKey, uuid });
  log(test);

  // this looks odd but is done so that if one is debugging and
  // looking at console.debug statements the experiment.variant aligns
  // with the qsVariant
  if (qsVariant) {
    test.variant = qsVariant;
  }

  return test;

}
